var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

/* eslint no-console:0 */
var color = require('colorette');

var _require = require('lodash'),
    isFunction = _require.isFunction,
    isNil = _require.isNil;

function log(message, userFn, colorFn) {
  if (!isNil(userFn) && !isFunction(userFn)) {
    throw new TypeError('Extensions to knex logger must be functions!');
  }

  if (isFunction(userFn)) {
    userFn(message);
    return;
  }

  console.log(colorFn ? colorFn(message) : message);
}

var Logger =
/*#__PURE__*/
function () {
  "use strict";

  function Logger(config) {
    _classCallCheck(this, Logger);

    var _config$log = config.log;
    _config$log = _config$log === void 0 ? {} : _config$log;
    var debug = _config$log.debug,
        warn = _config$log.warn,
        error = _config$log.error,
        deprecate = _config$log.deprecate;
    this._debug = debug;
    this._warn = warn;
    this._error = error;
    this._deprecate = deprecate;
  }

  _createClass(Logger, [{
    key: "debug",
    value: function debug(message) {
      log(message, this._debug);
    }
  }, {
    key: "warn",
    value: function warn(message) {
      log(message, this._warn, color.yellow);
    }
  }, {
    key: "error",
    value: function error(message) {
      log(message, this._error, color.red);
    }
  }, {
    key: "deprecate",
    value: function deprecate(method, alternative) {
      var message = "".concat(method, " is deprecated, please use ").concat(alternative);
      log(message, this._deprecate, color.yellow);
    }
  }]);

  return Logger;
}();

module.exports = Logger;